function productRowAnim(elementId) {
    const targetElement = document.getElementById(elementId);
    if (!targetElement) {
      return;
    }
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          targetElement.classList.add('nwh-promo-product-row--active');
        } else {
          targetElement.classList.remove('nwh-promo-product-row--active');
        }
      });
    }, options);
    observer.observe(targetElement);
  }